/* global window */
'use strict';

// This is just a wrapper around window.performance that stubs out some key
// methods of it when it's not available, so we can just use it without
// worrying about whether the browser supports it.

var noop = function () {};

var w;
// cautiously access window so that we can be a no-op when run outside
// of a browser context, e.g. in the unit tests.
try {
    w = window;
} catch (e) {
    w = {};
}

if (w.performance && w.performance.mark) {
    module.exports = w.performance;
} else {
    module.exports = {
        getEntriesByName: noop,
        mark: noop,
        measure: noop,
    };
}
